__turbopack_context__.v({
  "radiobutton": "RadioButtons-module-scss-module__zj1LvW__radiobutton",
  "radiobuttongroup": "RadioButtons-module-scss-module__zj1LvW__radiobuttongroup",
  "radiobuttongroup__content": "RadioButtons-module-scss-module__zj1LvW__radiobuttongroup__content",
  "radiobuttongroup__withcontent": "RadioButtons-module-scss-module__zj1LvW__radiobuttongroup__withcontent",
  "radiobuttonlabel": "RadioButtons-module-scss-module__zj1LvW__radiobuttonlabel",
  "radiobuttonwrapper": "RadioButtons-module-scss-module__zj1LvW__radiobuttonwrapper",
});
